import { Invoicing } from 'types/order';

const INVOICING_LABELS: Record<keyof Invoicing, string> = {
  name: 'Cégnév',
  address: 'Cím'
};

interface IProps {
  invoicing: Invoicing;
}

const InvoicingData = ({ invoicing }: IProps) => (
  <>
    <h3 className="text-xl font-semibold mb-4">Számlázási adatok</h3>

    <p className="mb-2">
      <span className="font-semibold">{INVOICING_LABELS.name}: </span>
      <span className="text-darkBlue-60">{invoicing.name}</span>
    </p>
    <p className="mb-2">
      <span className="font-semibold">{INVOICING_LABELS.address}: </span>
      <span className="text-darkBlue-60">{invoicing.address}</span>
    </p>
  </>
);

export default InvoicingData;
